// Non-intrusive placeholder for future AdSense placement. Renders a labeled slot
// only; no ad network code is loaded until you wire up AdSense.
export default function AdPlaceholder({ slot = "in-content", className = "" }) {
  if (process.env.REACT_APP_ADS_ENABLED !== "true") {
    return (
      <div
        data-testid={`ad-placeholder-${slot}`}
        data-ad-slot={slot}
        className={`flex items-center justify-center rounded-lg border border-dashed border-border bg-secondary/40 py-6 text-xs uppercase tracking-widest text-muted-foreground ${className}`}
        aria-hidden="true"
      >
        Advertisement
      </div>
    );
  }
  // When ads are enabled, render the ins tag for AdSense here.
  return <div data-testid={`ad-slot-${slot}`} data-ad-slot={slot} className={className} />;
}
